export const tumblrIcon = () => (
  <svg fill='none' height='24' width='24' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8.06 9.54H6.009V7.148a.244.244 0 0 1 .184-.283c2.362-.693 3.522-4.215 3.522-4.639 0-.155.1-.226.254-.226h2.191c.184 0 .213.071.213.226v4.427h4.356V9.54h-4.328c0 .042-.043 6.223 0 6.491a1.4 1.4 0 0 0 .735 1.02 3.04 3.04 0 0 0 2.192.299 9.57 9.57 0 0 0 1.98-.807v2.673a.243.243 0 0 1-.183.283 9 9 0 0 1-4.583.877 5.413 5.413 0 0 1-3.62-1.5 2.663 2.663 0 0 1-.905-1.9L8.06 9.54Z'
      fill='currentColor'
    />
  </svg>
);
